import {
  GSButton,
  GSInfoGroup,
} from "golfstatus_react_components";

import "./tournament-team-item.scss";
import { faBan } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { displayPlayerHandicap, displayTeamHandicap } from "../../../helpers/Handicaps";
import { selectCurrentTournament } from "../../../reducers/tournamentSlice";

const TournamentTeamItem = (props) => {
  const {
    name,
    contactName,
    players,
    flight,
    mainLeaderboardScoreDetails,
    disqualified,
  } = props;

  //callers spread the team into the item, and only some pass it and the
  //tournament along again. without them the handicaps came out blank.
  const currentTournament = useSelector(selectCurrentTournament);
  const team = props.team ?? props;
  const tournament = props.tournament ?? currentTournament;

  const contactInfo = {
    sectionItems: [
      {
        type: "primary full-width capitalize",
        value: `${name ?? `${contactName}'s Team`} ${displayTeamHandicap(
          team,
          tournament
        )}`,
      },
      {
        type: "secondary full-width",
        value: players
          ?.map?.((p) => `${p.name} ${displayPlayerHandicap(p, tournament)}`)
          ?.join?.(", "),
      },
    ],
  };

  const playerInfo = {
    sectionItems: [
      {
        type: "secondary full-width",
        value: players
          ?.map?.((p) => `${p.name} ${displayPlayerHandicap(p, tournament)}`)
          ?.join?.(", "),
      },
    ],
  };

  const flightInfo = {
    sectionItems: [
      {
        type: "secondary",
        value: `${flight?.name} flight`,
      },
    ],
  };

  const teamColumn = {
    fit: "stretch",
    sections:
      players?.length === 1 ? [{ ...playerInfo }] : [{ ...contactInfo }],
  };

  const dqColumn = {
    fit: "fit",
    sections: [
      {
        sectionItems: [
          {
            type: "primary",
            value: (
              <GSButton
                type="secondary status pill orange"
                title="Disqualified"
                buttonIcon={faBan}
              />
            ),
          },
        ],
      },
    ],
  };

  if (mainLeaderboardScoreDetails?.position) {
    flightInfo.sectionItems.unshift({
      type: "secondary",
      value: mainLeaderboardScoreDetails?.position,
    });
  }

  if (flight) {
    teamColumn.sections.push(flightInfo);
  }

  const getGroup = () => {
    let group = [{ ...teamColumn }];
    if (disqualified) {
      group.push({ ...dqColumn });
    }
    return group;
  };

  return (
    <tournament-team-item>
      <GSInfoGroup
        listType="mobile-vertical"
        dataGroups={getGroup()}
      ></GSInfoGroup>
    </tournament-team-item>
  );
};

export default TournamentTeamItem;
